/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_Q8Inputs */

const en_pc_faq_q8 = /** @type {(inputs: Pc_Faq_Q8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do I change the PdfCraft language?`)
};

const zh_pc_faq_q8 = /** @type {(inputs: Pc_Faq_Q8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如何修改 PdfCraft 的界面语言？`)
};

/**
* | output |
* | --- |
* | "How do I change the PdfCraft language?" |
*
* @param {Pc_Faq_Q8Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_q8 = /** @type {((inputs?: Pc_Faq_Q8Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_Q8Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_q8(inputs)
	return zh_pc_faq_q8(inputs)
});
export { pc_faq_q8 as "pc.faq.q8" }